import { defineAsyncComponent } from 'vue'
export default {
  portal: defineAsyncComponent(() => import("/home/kwesterfeld/ybd/ui/portal/src/layouts/portal.vue").then(m => m.default || m))
}